import React from "react"

export default function({ businessname }) {
  return <h1 className="business-name content-section">{businessname}</h1>
}
